var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.928 5.841h3.806v-3.84h-3.806V5.84zm-3.336.001v3.224H8.999V22.78H5.805V8.783c0-1.622 1.307-2.94 2.914-2.94h13.872zM9.142 26.16h13.873c1.606-.001 2.913-1.32 2.913-2.941V9.217h-3.193v13.716H9.142v3.222zm3.294-6.697H19.3v-6.926h-6.864v6.926zM5.806 30H2V26.16h3.806v3.84z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLat);
export default __webpack_public_path__ + "static/media/LAT.d01839afd84dabc68528e3f0d1a4f0a4.svg";
export { ForwardRef as ReactComponent };